// extracted by mini-css-extract-plugin
export default {"root":"SettingsItemDescription_root__3Ddri"};